import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/PoliticaCookies.css';

const PoliticaCookies = () => {
  return (
    <div className="legal-container">
      <h1>Política de Cookies</h1>
      <p className="update-date">Última actualización: 28 de mayo de 2025</p>

      <p>
        En Sana Servicios Dentales utilizamos cookies para brindarte una mejor experiencia en nuestro sitio web.
        Al navegar por nuestras páginas, aceptas el uso de cookies conforme a la presente política.
      </p>

      <h2>¿Qué son las cookies?</h2>
      <p>
        Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo (computadora, tablet, móvil)
        cuando visitas nuestro sitio. Nos ayudan a recordar tus preferencias, ofrecerte una navegación más personalizada
        y mejorar nuestros servicios.
      </p>

      <h2>Gestión de cookies</h2>
      <p>
        Puedes configurar tu navegador para aceptar o rechazar cookies, o para que te avise cuando una cookie va a ser almacenada.
        Ten en cuenta que desactivar algunas cookies puede afectar el funcionamiento del sitio web.
      </p>

      <h2>Modificaciones a esta política</h2>
      <p>
        Esta política puede actualizarse periódicamente. Te recomendamos revisarla de vez en cuando para estar informado sobre cómo usamos las cookies.
      </p>

      <p>
        Para más información sobre el uso de tus datos personales, consulta nuestro{' '}
        <Link to="/aviso-privacidad">Aviso de privacidad</Link>
 y nuestros{' '}
        <Link to="/terminos-condiciones">Términos y Condiciones</Link>.
      </p>
    </div>
  );
};

export default PoliticaCookies;